import { AppRouteProps } from "@bsm/component";
import React from "react";

const InvoiceDetails = React.lazy(() => import("./container/InvoiceDetails"))

export const InvoiceDetailsRoute = [
    {
        path: "invoice/:id",
        title: 'Bsm.Invoice.Details.Title',
        roles: ['INVOICE'],
        element: <InvoiceDetails />
    }
] as Array<AppRouteProps>